import React, { FC } from "react";

import { Column, DesktopMenuList, Row } from "../../../components";
import { SvgIcon } from "../../../components/Icons";
import {
  FootballIcon,
  OptionsIcon,
  OutdoorsIcon,
  RunningIcon,
  TrainingIcon,
  WinterIcon,
} from "../../../icons";

const DMSportsFlyout: FC = () => {
  return (
    <Row>
      <Column xs={2}>
        <OutdoorsIcon className="mb-4" />
        <DesktopMenuList
          titleLink={{ text: "Outdoors" }}
          linksItems={[
            { text: "Shoes" },
            { text: "Clothing" },
            { text: "Acessories" },
            { text: "Equipment" },
            { text: "Backpacks" },
            { text: "Tents" },
            { text: "Hiking" },
            { text: "Climbing" },
            { text: "Camping" },
            { text: "Horse Riding" },
            { text: "Fishing" },
            { text: "Hunting" },
            { text: "View all", classes: { root: "nav-menu__link--all" } },
          ]}
        />
      </Column>
      <Column xs={2}>
        <WinterIcon className="mb-4" />
        <DesktopMenuList
          titleLink={{ text: "Winter Sports" }}
          linksItems={[
            { text: "Shoes" },
            { text: "Clothing" },
            { text: "Acessories" },
            { text: "Equipment" },
            { text: "Skiing" },
            { text: "Snowboarding" },
            { text: "Ice Hockey" },
            { text: "Snow hiking" },
            { text: "Ice scating" },
            { text: "Nordic Walking" },
            { text: "Sledging" },
            { text: "View all", classes: { root: "nav-menu__link--all" } },
          ]}
        />
      </Column>
      <Column xs={2}>
        <RunningIcon className="mb-4" />
        <DesktopMenuList
          titleLink={{ text: "Running" }}
          linksItems={[
            { text: "Shoes" },
            { text: "Clothing" },
            { text: "Acessories" },
            { text: "Equipment" },
            { text: "Nutrition" },
            { text: "Trail-running" },
            { text: "Road-runnning" },
            { text: "Track-running" },
            { text: "Triathlon" },
            { text: "View all", classes: { root: "nav-menu__link--all" } },
          ]}
        />
      </Column>
      <Column xs={2}>
        <FootballIcon className="mb-4" />
        <DesktopMenuList
          titleLink={{ text: "Football" }}
          linksItems={[
            { text: "Shoes" },
            { text: "Jerseys" },
            { text: "Acessories" },
            { text: "Equipment" },
            { text: "Indoor football" },
            { text: "Outdoor football" },
            { text: "View all", classes: { root: "nav-menu__link--all" } },
          ]}
        />
      </Column>
      <Column xs={2}>
        <TrainingIcon className="mb-4" />
        <DesktopMenuList
          titleLink={{ text: "Fitness and training" }}
          linksItems={[
            { text: "Shoes" },
            { text: "Jerseys" },
            { text: "Acessories" },
            { text: "Equipment" },
            { text: "Fitness" },
            { text: "Athletics" },
            { text: "Dance" },
            { text: "Ballet" },
            { text: "Yoga" },
            { text: "Gymnastics" },
            { text: "View all", classes: { root: "nav-menu__link--all" } },
          ]}
        />
      </Column>
      <Column xs={2}>
        <OptionsIcon className="mb-4" />
        <DesktopMenuList
          titleLink={{ text: "All Sports" }}
          linksItems={[
            { text: "All Sports" },
            { text: "Cycling" },
            { text: "Basketball" },
            { text: "Baseball" },
            { text: "Voleyball" },
            { text: "Rugby" },
            { text: "Handball" },
            { text: "Water sports" },
            { text: "Martial Arts & Boxing" },
            { text: "Racket sports" },
            { text: "Games and Activities" },
            { text: "View all", classes: { root: "nav-menu__link--all" } },
          ]}
        />
      </Column>
    </Row>
  );
};

export default DMSportsFlyout;
